import axios from 'axios'

class Banners {
    get(filter = {}) {
        return axios.get(`/api/v1/banners`, filter)
    }

    updateOrder(orderData = []) {
        return axios.put('/api/v1/banners/order', orderData)
    }
}

export default Banners
